import React from 'react'
import PropTypes from 'prop-types'

const CURSOR_CLICK_PATH = 'M14.6625 16.125L12.1875 13.6688L11.625 15.375C11.5625 15.55 11.4437 15.6344 11'
  + '.2687 15.6281C11.0937 15.6219 10.975 15.5313 10.9125 15.3563L9.20625 9.675C9.1'
  + '5625 9.5375 9.1875 9.4125 9.3 9.3C9.4125 9.1875 9.5375 9.15625 9.675 9.20625L1'
  + '5.3562 10.9125C15.5312 10.975 15.6219 11.0938 15.6281 11.2688C15.6344 11.4438 '
  + '15.55 11.5625 15.375 11.625L13.6687 12.1875L16.1437 14.6625C16.3562 14.875 16.'
  + '4625 15.1188 16.4625 15.3938C16.4625 15.6688 16.3562 15.9125 16.1437 16.125C15'
  + '.9312 16.3375 15.6844 16.4438 15.4031 16.4438C15.1219 16.4438 14.875 16.3375 1'
  + '4.6625 16.125ZM4.5 9C4.5 7.75 4.9375 6.6875 5.8125 5.8125C6.6875 4.9375 7.75 4'
  + '.5 9 4.5C9.9625 4.5 10.8219 4.76562 11.5781 5.29688C12.3344 5.82813 12.875 6.5'
  + '1875 13.2 7.36875C13.275 7.56875 13.2719 7.7625 13.1906 7.95C13.1094 8.1375 12'
  + '.9687 8.26875 12.7687 8.34375C12.5687 8.41875 12.3781 8.41563 12.1969 8.33438C'
  + '12.0156 8.25313 11.8875 8.1125 11.8125 7.9125C11.6 7.35 11.2375 6.89063 10.725'
  + ' 6.53438C10.2125 6.17813 9.6375 6 9 6C8.175 6 7.46875 6.29375 6.88125 6.88125C'
  + '6.29375 7.46875 6 8.175 6 9C6 9.6375 6.17812 10.2125 6.53437 10.725C6.89062 11'
  + '.2375 7.35 11.6 7.9125 11.8125C8.1125 11.8875 8.25312 12.0188 8.33437 12.2063C'
  + '8.41562 12.3938 8.41875 12.5875 8.34375 12.7875C8.26875 12.9875 8.1375 13.125 '
  + '7.95 13.2C7.7625 13.275 7.56875 13.275 7.36875 13.2C6.50625 12.875 5.8125 12.3'
  + '281 5.2875 11.5594C4.7625 10.7906 4.5 9.9375 4.5 9Z'

const CursorClickIcon = ({ className = '' }) => (
  <svg
    aria-hidden="true"
    className={className}
    fill="currentColor"
    height="1em"
    viewBox="0 0 18 18"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d={CURSOR_CLICK_PATH} />
  </svg>
)

CursorClickIcon.propTypes = {
  className: PropTypes.string
}

CursorClickIcon.defaultProps = {
  className: ''
}

export default CursorClickIcon
